import { config } from '../config';
import { authHeader } from '../helpers';
import axiosInstance from '../axiosInstance';

export const brokerHouseService = {
  getBrokerHouseCodes,
  addBrokerHouseCode,
  updateBrokerHouseCode,
  deleteBorkerHouseCode
};

function getBrokerHouseCodes() {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };
  return axiosInstance
    .get(`${config.brokerHouseServer}`, requestOptions)
    .then((response) => response.data);
}

function addBrokerHouseCode(data) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };
  return axiosInstance
    .post(`${config.brokerHouseServer}`, data, requestOptions)
    .then((response) => response.data);
}

function updateBrokerHouseCode(data) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };
  return axiosInstance
    .put(`${config.brokerHouseServer}/${data._id}`, data, requestOptions)
    .then((response) => response.data);
}

function deleteBorkerHouseCode(id) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };
  return axiosInstance
    .delete(`${config.brokerHouseServer}/${id}`, requestOptions)
    .then((response) => response.data);
}
